@if (isUnified) {
  <!-- Unified Code: statistics as tokenised stat cards (a div, so the Custom `section .container ul` rules do not apply). -->
  <div class="uc-home-section uc-stats">
    <div class="container">
      <ul class="uc-stats__grid">
        <li class="uc-card uc-stats__item"><ng-container *ngTemplateOutlet="ucStat; context: {counter: hoursCounter, title: 'home.counter.studyHours', icon: 'timer'}"></ng-container></li>
        <li class="uc-card uc-stats__item"><ng-container *ngTemplateOutlet="ucStat; context: {counter: pathsCounter, title: 'home.counter.learningPaths', icon: 'track'}"></ng-container></li>
        <li class="uc-card uc-stats__item"><ng-container *ngTemplateOutlet="ucStat; context: {counter: studentCounter, title: 'home.counter.interns', icon: 'users'}"></ng-container></li>
        <li class="uc-card uc-stats__item"><ng-container *ngTemplateOutlet="ucStat; context: {counter: courseCounter, title: 'home.counter.courses', icon: 'book'}"></ng-container></li>
      </ul>
    </div>
  </div>
  <ng-template #ucStat let-counter="counter" let-title="title" let-icon="icon">
    <span class="uc-stats__icon" aria-hidden="true"><span class="icon-mask" [style.mask-image]="'url(assets/imgs/' + icon + '.svg)'"></span></span>
    <span class="uc-stats__value uc-display-sm uc-semibold">{{ counter }}</span>
    <span class="uc-stats__label uc-text-md" translate="{{ title }}"></span>
  </ng-template>
} @else {
<section class="pb-5">
  <div class="container">
    <ul class="d-md-flex align-items-center justify-content-between">
      <li>
        <ng-template *ngTemplateOutlet="counterTemplate; context: {counter: hoursCounter, title: 'home.counter.studyHours', icon: 'timer'}"></ng-template>
      </li>
      <li class="d-none d-md-block">
        <span></span>
      </li>
      <li>
        <ng-template *ngTemplateOutlet="counterTemplate; context: {counter: pathsCounter, title: 'home.counter.learningPaths', icon: 'track'}"></ng-template>
      </li>
      <li class="d-none d-md-block">
        <span></span>
      </li>
      <li>
        <ng-template *ngTemplateOutlet="counterTemplate; context: {counter: studentCounter, title: 'home.counter.interns', icon: 'users'}"></ng-template>
      </li>
      <li class="d-none d-md-block">
        <span></span>
      </li>
      <li>
        <ng-template *ngTemplateOutlet="counterTemplate; context: {counter: courseCounter, title: 'home.counter.courses', icon: 'book'}"></ng-template>
      </li>
    </ul>
  </div>
</section>
<ng-template #counterTemplate let-counter="counter" let-title="title" let-icon="icon">
  <div class="item d-flex flex-column align-items-center justify-content-center">
    <div class="rounded-circle d-flex align-items-center justify-content-center">
      <span class="icon-mask {{icon}}"></span>
    </div>
    <h3 class="mb-0">{{counter}}</h3>
    <p class="mb-0" translate="{{title}}"></p>
  </div>
</ng-template>
}
